__turbopack_context__.v({
  "root": "TrampolineMoveNetwork-module__bnH14a__root",
});
